import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDecodedParams } from "../misc/utils";
import styles from "./ConfirmationPage.module.scss";
import { useSetMember } from "../misc/utils";

const ConfirmationPage = () => {
  const { t } = useTranslation();
  const { type } = useDecodedParams();
  const navigate = useNavigate();
  const [dataLoaded, setDataLoaded] = useState(false);

  const [data, setData] = useState({});
  const mem = useSetMember();
  const memberType = mem.getMember();
  const {
    paymentMethod,
    donationAmount,
    prefix,
    parentEnglishLastname,
    emergencyname,
    othername,
    IDname,
    parentEnglishFirstame,
    englishLastname,
    englishFirstame,
    parentname,
    gender,
    confirmEmail,
    phoneType,
    phoneNumber,
    emergencyContactPhoneNumber,
    emergencycontactEnglishFirstname,
    emergencycontactEnglishLastname,
    birthYear,
    birthMonth,
    birth_date,
    date,
    receiptName,
    receiptAddress,
    job,
    livingArea,
    option,
    skuName,
    promoMoney,
    files,
  } = data;

  useEffect(() => {
    setData(() => {
      if (!type) {
        navigate(-1);
      } else if (type === "donation") {
        return JSON.parse(window.sessionStorage.getItem("donation"));
      } else if (type === "event") {
        return JSON.parse(window.sessionStorage.getItem("event"));
      }
    });
    setDataLoaded(true);
  }, [type]);

  useEffect(() => {
    if (dataLoaded) {
      processEventEnrollmentData(data);
    }
  }, [data, dataLoaded]);

  const handleSubmit = () => {
    if (type === "donation") {
      navigate("/payment/donation");
    } else if (type === "event") {
      navigate("/payment/event", { state: { passed: true } });
    }
  };

  // console.log("Here:", data);

  const processEventEnrollmentData = (data) => {
    // console.log("here is the data");
    // console.log(data);
    const p = {
      event_id: data.event_id,
      detail: {
        name: {
          prefix: data.prefix,
          en_full_name: data.parentname,
        },
        child_full_name: data.IDname,
        child_other_name: data.othername,
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        emergency_contact_phone_number: data.emergencyContactPhoneNumber,
        emergency_contact_full_name: data.emergencyname,
        birth_date: data.date,
        supporting_doc: data?.files?.length
          ? data.files.map((file) => file.data.filename)
          : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
      promoMoney: data.promoMoney,
      promo_terms: data["pi-0"] ? "yes" : "no",
      film_terms: data["pi-1"] ? "yes" : "no",
      payment_method: data.paymentMethod,
      member_status: data.option.memberStatus,
    };
    // console.log("here is the prepared data");
    // console.log(p);
    return p;
  };

  console.log(data);

  return memberType === "nonmember" ? (
    <div className="page-view event-detail">
      <form style={{ marginTop: 36 }}>
        <div
          className={`card-view donation-card donation-result-card`}
          style={{ marginBottom: "40px" }}
        >
          <h1 className="mt-2 mb-1">{t("Confirmation")}</h1>
          <h4 className="">
            {type === "donation" ? t("Donation") : t("Class Enrolment")}
          </h4>
          {type === "donation" ? (
            <>
              <div className={styles["item-container"]}>
                <TextItem label="捐款金額" value={donationAmount} />
              </div>
              {receiptName ? (
                <>
                  <div className={styles["item-container"]}>
                    <TextItem label="免稅收據抬頭名稱" value={receiptName} />
                  </div>
                  <div className={styles["item-container"]}>
                    <TextItem label="收據郵奇地址" value={receiptAddress} />
                  </div>
                </>
              ) : null}
              <div className={styles["divider"]} />
              <div className={styles["item-container"]}>
                <TextItem label="稱謂" value={prefix} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="中文姓氏" value={parentEnglishLastname} />
                <TextItem label="中文名字" value={parentEnglishFirstame} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="英文姓氏" value={englishLastname} />
                <TextItem label="英文姓氏" value={englishFirstame} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="性別" value={gender} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="電郵" value={confirmEmail} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="聯絡電話類型" value={phoneType} />
                <TextItem label="電話" value={phoneNumber} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="出生月份" value={birthMonth} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem
                  label="接收推廣資訊"
                  value={data["pi-1"] ? "是" : "否"}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="付款方法" value={paymentMethod} />
              </div>
            </>
          ) : (
            <>
              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Class Name")}
                  value={`${skuName} - ${option?.description}`}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={"Promo Value"} value={promoMoney} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Total Amount")}
                  value={option?.price - promoMoney}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Status")} value={option?.memberStatus} />
              </div>
              <div className={styles["divider"]} />
              <div className={styles["item-container"]}>
                <TextItem label={t("Title")} value={prefix} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Parent's Name")} value={parentname} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Kids First Name")} value={IDname} />
                <TextItem label={t("Kids Other Name")} value={othername} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Gender")} value={gender} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Email")} value={confirmEmail} />
                <TextItem label={t("Phone")} value={phoneNumber} />
              </div>
              <div className={styles["item-container"]}>
                {/* <TextItem label="聯絡電話類型" value={phoneType} /> */}
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Date of Birth")} value={date} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Emergency Contact Name")}
                  value={emergencyname}
                />
              </div>

              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Emergency Contact Phone Number")}
                  value={emergencyContactPhoneNumber}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Receive Promotional Information")}
                  value={data["pi-0"] ? "Yes" : "No"}
                />
                <TextItem
                  label={t("Agree to Shoot Video")}
                  value={data["pi-1"] ? "Yes" : "No"}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Payment Methods")} value={paymentMethod} />
              </div>
              {files?.length ? (
                <>
                  <div className={styles["divider"]} />
                  <h5 style={{ marginBottom: "8px" }}>
                    {t("Additional materials")}
                  </h5>
                  {files?.length
                    ? files.map((file, i) => {
                        return <FileItem value={file.data.filename} />;
                      })
                    : null}
                </>
              ) : null}
            </>
          )}
        </div>
        <div className={`my-5 btns-gp-div`}>
          <Button
            sx={{ marginRight: 2 }}
            onClick={() => {
              navigate(-1);
            }}
            style={{ borderColor: "#fa8123", color: "#fa8123" }}
          >
            {t("Back")}
          </Button>
          <Button
            variant="contained"
            sx={{ marginRight: 2 }}
            onClick={handleSubmit}
            style={{
              backgroundColor: "#FFA836", // Change this color to your desired color
              color: "#FFFFFF", // Change the text color if needed
            }}
          >
            {t("Submit")}
          </Button>
        </div>
      </form>
    </div>
  ) : (
    <div className="page-view event-detail">
      <form style={{ position: "relative", marginTop: 32 }}>
        <img
          className="logo logo-absolute"
          src="/EP_logo_withwords-01.png"
          alt="pause-and-breathe-logo"
        />
        <div
          className={`card-view donation-card donation-result-card`}
          style={{ marginBottom: "40px" }}
        >
          <h1 className="mt-2 mb-1">{t("Confirmation")}</h1>
          <h4 className="">
            {type === "donation" ? t("Donation") : t("Class Enrolment")}
          </h4>
          {type === "donation" ? (
            <>
              <div className={styles["item-container"]}>
                <TextItem label="捐款金額" value={donationAmount} />
              </div>
              {receiptName ? (
                <>
                  <div className={styles["item-container"]}>
                    <TextItem label="免稅收據抬頭名稱" value={receiptName} />
                  </div>
                  <div className={styles["item-container"]}>
                    <TextItem label="收據郵奇地址" value={receiptAddress} />
                  </div>
                </>
              ) : null}
              <div className={styles["divider"]} />
              <div className={styles["item-container"]}>
                <TextItem label="稱謂" value={prefix} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="中文姓氏" value={parentEnglishLastname} />
                <TextItem label="中文名字" value={parentEnglishFirstame} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="英文姓氏" value={englishLastname} />
                <TextItem label="英文姓氏" value={englishFirstame} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="性別" value={gender} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="電郵" value={confirmEmail} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="聯絡電話類型" value={phoneType} />
                <TextItem label="電話" value={phoneNumber} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="出生月份" value={birthMonth} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem
                  label="接收推廣資訊"
                  value={data["pi-1"] ? "是" : "否"}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label="付款方法" value={paymentMethod} />
              </div>
            </>
          ) : (
            <>
              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Class Name")}
                  value={`${skuName} - ${option?.description}`}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={"Promo Value"} value={promoMoney} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Total Amount")}
                  value={option?.price - promoMoney}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Status")} value={option?.memberStatus} />
              </div>
              <div className={styles["divider"]} />

              <div className={styles["item-container"]}>
                <TextItem label={t("Kids First Name")} value={IDname} />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Phone")} value={phoneNumber} />
              </div>

              <div className={styles["item-container"]}>
                <TextItem
                  label={t("Receive Promotional Information")}
                  value={data["pi-0"] ? "Yes" : "No"}
                />
                <TextItem
                  label={t("Agree to Shoot Video")}
                  value={data["pi-1"] ? "Yes" : "No"}
                />
              </div>
              <div className={styles["item-container"]}>
                <TextItem label={t("Payment Methods")} value={paymentMethod} />
              </div>
              {files?.length ? (
                <>
                  <div className={styles["divider"]} />
                  <h5 style={{ marginBottom: "8px" }}>
                    {t("Additional materials")}
                  </h5>
                  {files?.length
                    ? files.map((file, i) => {
                        return <FileItem value={file.data.filename} />;
                      })
                    : null}
                </>
              ) : null}
            </>
          )}
        </div>
        <div className={`my-5 btns-gp-div`}>
          <Button
            sx={{ marginRight: 2 }}
            onClick={() => {
              navigate(-1);
            }}
            style={{ borderColor: "#fa8123", color: "#fa8123" }}
          >
            {t("Back")}
          </Button>
          <Button
            variant="contained"
            sx={{ marginRight: 2 }}
            onClick={handleSubmit}
            style={{
              backgroundColor: "#FFA836", // Change this color to your desired color
              color: "#FFFFFF", // Change the text color if needed
            }}
          >
            {t("Submit")}
          </Button>
        </div>
      </form>
    </div>
  );
};

const TextItem = ({ label, value }) => {
  return (
    <div className={styles["text-item"]}>
      <h5>{label || ""}</h5>
      <p>{value || "N/A"}</p>
    </div>
  );
};

const FileItem = ({ label, value }) => {
  return (
    <div className={styles["file-item"]}>
      <p>{value || "N/A"}</p>
    </div>
  );
};

export default ConfirmationPage;
